// components/cart/CheckoutButtons.js
import React, { memo } from 'react';
import tw from 'twin.macro';
import CheckoutProButton from '../CheckoutProMP';
import Spinner from 'components/Spinner';

const Container = tw.div`flex flex-col w-full`;
const FinalizarCompraButton = tw.button`px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-800 mt-2`;
const MpFloating = tw.div`fixed [left:10px] bottom-0 z-50 lg:static lg:bottom-auto lg:right-auto`;

const CheckoutButtons = memo(
	({ metodoPago, isLoading, preferenceId, handleFinalizarCompraTransferencia, handleFinalizarCompraEfectivo }) => {
		const isMpReady = metodoPago === 'mercado-pago' && !isLoading && preferenceId;

		return (
			<Container>
				{metodoPago === 'mercado-pago' &&
					(!isMpReady ?
						<Spinner text="Creando link de pago..." />
					:	<MpFloating>
							<CheckoutProButton preferenceId={preferenceId} />
						</MpFloating>)}
				{metodoPago === 'transferencia' && (
					<FinalizarCompraButton onClick={handleFinalizarCompraTransferencia}>
						Finalizar Compra
					</FinalizarCompraButton>
				)}
				{metodoPago === 'efectivo' && (
					<FinalizarCompraButton onClick={handleFinalizarCompraEfectivo}>
						Finalizar Compra
					</FinalizarCompraButton>
				)}
			</Container>
		);
	},
);

CheckoutButtons.displayName = 'CheckoutButtons';

export default CheckoutButtons;
